import { render } from "./InjuryPartAlysis.vue?vue&type=template&id=3d07783a&scoped=true"
import script from "./InjuryPartAlysis.vue?vue&type=script&lang=js"
export * from "./InjuryPartAlysis.vue?vue&type=script&lang=js"

import "./InjuryPartAlysis.vue?vue&type=style&index=0&id=3d07783a&lang=scss&scoped=true"
import "./InjuryPartAlysis.vue?vue&type=style&index=1&id=3d07783a&lang=scss&scoped=true"
import "./InjuryPartAlysis.vue?vue&type=style&index=2&id=3d07783a&scoped=true&lang=css"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d07783a"]])

export default __exports__